export default "__VITE_ASSET__BLOP5dXv__"